import { render, staticRenderFns } from "./DocumentSigningKioskView.vue?vue&type=template&id=2d2ba388&scoped=true"
import script from "./DocumentSigningKioskView.vue?vue&type=script&lang=js"
export * from "./DocumentSigningKioskView.vue?vue&type=script&lang=js"
import style0 from "./DocumentSigningKioskView.vue?vue&type=style&index=0&id=2d2ba388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ba388",
  null
  
)

export default component.exports